import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d6fe86bc"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "floor"
}
const _hoisted_2 = { class: "current-floor" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " / ", -1 /* HOISTED */))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "door-wrapper" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "door" }, [
    /*#__PURE__*/_createElementVNode("p", null, "출입문")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "driver-seat" }, [
    /*#__PURE__*/_createElementVNode("p", null, "운전석")
  ])
], -1 /* HOISTED */))
const _hoisted_5 = { class: "seat-grid-container" }
const _hoisted_6 = ["id", "onClick"]
const _hoisted_7 = {
  key: 0,
  class: "img-booked",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "m12 4-8 8M4 4l8 8",
  stroke: "#fff",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1 /* HOISTED */))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(["seat-layout-wrapper", { selectable: $props.selectable }])
  }, [
    ($props.totalFloor > 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("span", _hoisted_2, _toDisplayString($props.currentFloor) + "F", 1 /* TEXT */),
          _hoisted_3,
          _createElementVNode("span", null, _toDisplayString($props.totalFloor) + "F", 1 /* TEXT */)
        ]))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", {
      class: _normalizeClass(["layout", { 'no-floor-label': $props.totalFloor <= 1 }])
    }, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.seatsInfo, (seatInfo, index) => {
          return (_openBlock(), _createElementBlock("div", { key: index }, [
            (seatInfo?.seatNo?.length && seatInfo?.seatNo?.length > 0)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass(["seat", {
              selected: $setup.isSelectedSeat(seatInfo),
              booked: $props.selectable && seatInfo?.bookedBySomeone,
              duplicated: seatInfo?.seatNo === $props.duplicateSeatNo,
            }]),
                  id: seatInfo?.seatNo,
                  onClick: ($event: any) => ($setup.onClickSeat(seatInfo!))
                }, [
                  ($props.selectable && seatInfo?.bookedBySomeone)
                    ? (_openBlock(), _createElementBlock("svg", _hoisted_7, [..._hoisted_9]))
                    : (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(seatInfo?.seatNo), 1 /* TEXT */))
                ], 10 /* CLASS, PROPS */, _hoisted_6))
              : _createCommentVNode("v-if", true)
          ]))
        }), 128 /* KEYED_FRAGMENT */))
      ]),
      _createCommentVNode(" <div class=\"seat-row-label-container\">\n        <p class=\"seat-row-label\" v-for=\"label in seatRowLabels\" :key=\"label\">\n          {{ label }}\n        </p>\n      </div> ")
    ], 2 /* CLASS */)
  ], 2 /* CLASS */))
}